type Providers = {
  runAll: (opts: any) => Promise<any>;
  runSourceScraper: (opts: any) => Promise<any>;
  runEmbedScraper: (opts: any) => Promise<any>;
  listSources: () => any[];
  listEmbeds: () => any[];
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function getProviders(): Providers | null {
  return null;
}
